import { apiClient as api } from "./httpClient";

/** vigente | agendado | vencido — calculado da vigência, não armazenado. */
export type DataAccessSituation = "vigente" | "agendado" | "vencido";

export interface DataAccessRow {
  id: string;
  supervisorId: string;
  supervisorName: string;
  supervisedId: string;
  supervisedName: string;
  initialDate: string | null;
  finalDate: string | null;
  situation: DataAccessSituation;
  /** Atende este paciente? A tela sinaliza quem é de fora da equipe. */
  supervisorAttends: boolean;
  supervisedAttends: boolean;
}

export interface ProfessionalOption {
  id: string;
  name: string;
  attends: boolean;
}

export interface PatientDataAccessResponse {
  items: DataAccessRow[];
  professionals: ProfessionalOption[];
}

export interface SaveDataAccessPayload {
  id?: string;
  patientId: string;
  supervisorId: string;
  supervisedId: string;
  initialDate: string | null;
  finalDate: string | null;
}

const MENSAGENS: Record<string, string> = {
  "PatientDataAccess.SameProfessional":
    "Escolha profissionais diferentes: quem vê e quem tem os dados vistos não podem ser a mesma pessoa.",
  "PatientDataAccess.InvalidPeriod": "A data final não pode ser anterior à inicial.",
  "PatientDataAccess.Duplicated":
    "Esta dupla já tem acesso ativo neste paciente. Para renovar o prazo, edite a concessão existente.",
  "PatientDataAccess.ProfessionalNotFound": "Profissional não encontrado entre os ativos da entidade.",
  "PatientDataAccess.Unauthorized": "Você não tem permissão para administrar o acesso deste paciente.",
};

export const dataAccessErrorMessage = (e: unknown, padrao: string): string => {
  const code = (e as { response?: { data?: { code?: string } } })?.response?.data?.code;
  return (code && MENSAGENS[code]) || padrao;
};

export const patientDataAccessService = {
  getByPatient: async (patientId: string): Promise<PatientDataAccessResponse> => {
    const response = await api.get(`/patient-data-access/by-patient/${patientId}`);
    return response.data;
  },

  save: async (payload: SaveDataAccessPayload): Promise<string> => {
    const response = await api.post(`/patient-data-access`, payload);
    return response.data.id as string;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/patient-data-access/${id}`);
  },
};
